import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { useDocumentMeta } from '../shared/seo/useDocumentMeta';

/**
 * The application shell.
 *
 * The search box lives in the header on every route, including the public
 * company pages, because a visitor arriving from a search engine is the product's
 * main acquisition channel (section 23.8) and must be able to start a check
 * immediately.
 *
 * The title, description and canonical link are applied here rather than in each
 * page: every routed screen needs them, and a page that forgets would inherit
 * the previous page's title — which is how a browser history fills up with
 * identical entries and how a shared link gets described in the wrong language.
 */
export function Layout(): React.ReactNode {
  useDocumentMeta();

  return (
    <div className="flex min-h-dvh flex-col bg-[var(--color-bg)] text-[var(--color-fg)]">
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
